import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { BaseComponent } from '@macs-frontend/core';

@Component({
  selector: 'md-subheader',
  templateUrl: 'subheader.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubheaderComponent extends BaseComponent {
  @Input() showAddBtn = true;
  @Output() addButtonClick: EventEmitter<any> = new EventEmitter<any>();

  add() {
    this.addButtonClick.emit();
  }
}
